import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/DoorAccess/ElevatorHub.jpg";
import image from "../../assets/product-list-assets/cameras/door-access/elevator-hub.jpg";
import type { Product } from "../../types";
import { controlHubs } from "../product-list-groups/controlHubs";

export const elevatorHub: Product = {
  id: "elevatorHub",
  productTitle: "Elevator Hub",
  description: "elevatorHub.description",
  productListGroup: controlHubs,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-sk-elevator"],
  storePathParts: {
    category: "door-access-hub",
    productSlug: "ua-sk-elevator",
  },
  customBadges: [
    {
      value: {
        type: "translation",
        value: "commons.badge.kitIncluded",
      },
      variant: "lightGrey",
    },
  ],
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 257,
    height: 182,
  },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '129.3 x 244.7 x 33.6 mm\n(5.1 x 9.6 x 1.3")',
      },
    },
    {
      propertyId: "outputRelays",
      value: {
        type: "translation",
        value: "elevatorHub.outputRelays",
      },
    },
    {
      propertyId: "inputTerminals",
      value: {
        type: "translation",
        value: "elevatorHub.inputTerminals",
      },
    },
    {
      propertyId: "poePorts",
      value: {
        type: "translation",
        value: "elevatorHub.poePorts",
      },
    },
    {
      propertyId: "accessPowerMethod",
      value: {
        type: "string",
        value: "PoE++",
      },
    },
    {
      propertyId: "powerRedundancy",
      value: { type: "boolean", value: false },
    },
  ],
};
